// The tabs of Settings › Engagement types. Split out of EngagementTypes.tsx (performance-closure, plan
// §10.2) so the route validates `?tab=` without loading the screen up front.
export const ENGAGEMENT_TYPE_TABS = ['general', 'fields'] as const;
export type EngagementTypeTab = (typeof ENGAGEMENT_TYPE_TABS)[number];
